import { toZonedTime } from 'date-fns-tz';

export const parseDateValue = (val, tz) => {
  if (!val) return null;

  // If it's already a Date, just zone it
  if (val instanceof Date) return toZonedTime(val, tz);

  // Numeric timestamp
  if (typeof val === 'number') return toZonedTime(new Date(val), tz);

  if (typeof val === 'string') {
    // YYYY-MM-DD (date-only)
    if (/^\d{4}-\d{2}-\d{2}$/.test(val)) {
      const [year, month, day] = val.split('-').map(Number);
      return new Date(year, month - 1, day);
    }

    // M/D/YYYY or MM/DD/YYYY (date-only)
    if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(val)) {
      const [month, day, year] = val.split('/').map(Number);
      return new Date(year, month - 1, day);
    }

    // ISO datetime (with time)
    if (/^\d{4}-\d{2}-\d{2}T/.test(val)) {
      return toZonedTime(new Date(val), tz);
    }
  }

  return toZonedTime(new Date(val), tz);
};
